/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import { ButtonContainer } from 'yurstrap';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    title: '',
};

const TabMenuButtonContainer = (props) => {
    const classNames = [
        'c-tab-menu__btn',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <ButtonContainer>
                {props.children}
            </ButtonContainer>
        </props.componentClass>
    );
};

TabMenuButtonContainer.propTypes = propTypes;

TabMenuButtonContainer.defaultProps = defaultProps;

export default TabMenuButtonContainer;
